import { useTranslation } from 'react-i18next'
import { PageHeader, ListView } from 'components'
import ExternalDashboardCell from './externalDashboardCell'

export default function ExternalDashboardsScreen(props) {
  const { data: externalDashboards, onQuery, onSelect } = props
  const { t } = useTranslation(null, { useSuspense: false })

  return (
    <div className='external-dashboards-comp page'>
      <PageHeader title={t('externalDashboards.externalDashboard', { count: 100 })}/>
      <ListView
        data={externalDashboards}
        cell={ExternalDashboardCell}
        onQuery={onQuery}
        onSelect={onSelect}
      />
    </div>
  )
}